// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__Ar+wW","muted":"Pill_muted__hACK6","solid":"Pill_solid__bWhNS","dark":"Pill_dark__69mid","sm":"Pill_sm__Q+bVo","interactive":"Pill_interactive__WK5Jr"};